import React from 'react'
import styles from './Masthead.scss'
import appStyles from '../../App/appStyles.scss'
import { normalBlock } from '../../App/blockSizes.scss'
import cx from 'classnames'
import { Heart } from 'common/Heart'

export const Masthead = ({ title, subtitle, liked, likesCount, onHeartClick }) => (
  <div className={cx(styles.Masthead, normalBlock)}>
    <h1 className={appStyles.title}>{title}</h1>
    <h2 className={appStyles.subtitle}>{subtitle}</h2>
    <Heart liked={liked} count={likesCount} onClick={onHeartClick} />
  </div>
)
